'use strict'

module.exports = function(value){
    return !isNaN( parseFloat( value ) ) && isFinite( value )
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/i-s/src/numeric.js
 ** module id = 852
 ** module chunks = 0
 **/